import { generateActions } from "utils/generateActions";

export const ADD_POST = generateActions("ADD_POST");
export const UPDATE_POST = generateActions("UPDATE_POST");
export const GET_POST = generateActions("GET_POST");
export const GET_TABLE_POSTS = generateActions("GET_TABLE_POSTS");